module.exports = new __parcel__URL__("correct_config_in_baggy_and_ecoflex.b0ba557d.png").toString();